// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"0d4f6867","141":"caa0be06","305":"f091af8d","306":"38bab285","787":"e59be3f0","877":"d3396efb","994":"d37ecac5"}[chunkId] + ".chunk.js";
};